function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useCallback, useState } from 'react';
import ClaimGroupPageContainer from '../containers/ClaimGroupPageContainer';
import { useTranslation } from 'react-i18next';
import claimGroupService from '../../services/claim_group.service';
import ClaimGroupEditFooter from '../../claim_group/edit/ClaimGroupEditFooter';
import { useSetCompanyBreadcrumb } from '../../util/hooks/useSetCompanyBreadcrumb';
export default function AbstractClaimGroupChildPage(_ref) {
  let {
    highlightedMenuItem,
    ClaimGroupChildPage
  } = _ref;
  return function WrappedPage(_ref2) {
    let {
      accountType,
      handleToaster,
      ...props
    } = _ref2;
    const {
      t
    } = useTranslation();
    const [claimGroup, setClaimGroup] = useState(null);
    const [pageIsLoading, setPageIsLoading] = useState(false);
    useSetCompanyBreadcrumb(claimGroup?.company, accountType);
    const resetClaimGroup = claimGroupService.useFetchClaimGroupAndUpdateTechnicalReviewState({
      claimGroupId: claimGroup?.id,
      setClaimGroup
    });
    const updateClaimGroupCallback = claimGroupService.useUpdateClaimGroup({
      setClaimGroup
    });
    const updateClaimGroup = useCallback(async _ref3 => {
      let {
        updatedClaimGroup = {}
      } = _ref3;
      await updateClaimGroupCallback({
        ...claimGroup,
        ...updatedClaimGroup
      });
    }, [claimGroup, updateClaimGroupCallback]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimGroupPageContainer, {
      highlightedMenuItem: highlightedMenuItem,
      accountType: accountType,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup
    }, /*#__PURE__*/React.createElement(ClaimGroupChildPage, _extends({
      accountType: accountType,
      handleToaster: handleToaster,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup,
      resetClaimGroup: resetClaimGroup,
      updateClaimGroup: updateClaimGroup,
      pageIsLoading: pageIsLoading,
      setPageIsLoading: setPageIsLoading,
      t: t
    }, props))));
  };
}